import ImageDisplay from "./ImageDisplay";
import ProductInfo from "./ProductInfo";
import Exhibition from "./Exhibition";

function Main(props) {
  return (
    <div className="main">
      <ImageDisplay />
      <ProductInfo isEmpty={props.isEmpty} handleCart={props.handleCart} />
      <Exhibition />
    </div>
  );
}

export default Main;
